import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import tradeApi from "./tradeApi";

export const getTradeInsertForm = createThunkFromApi(
  "trade/getTradeInsertForm",
  tradeApi.getTradeInsertForm
);

export const getTradeAmountMax = createThunkFromApi(
  "trade/getTradeAmountMax",
  tradeApi.getTradeAmountMax
);

export const getTradeList = createThunkFromApi(
  "trade/getTradeList",
  tradeApi.getTradeList
)

export const getTradeForm = createThunkFromApi(
  "trade/getTradeForm",
  tradeApi.getTradeForm
)

export const getTradeLast24HList = createThunkFromApi(
  "trade/getTradeLast24HList",
  tradeApi.getTradeLast24HList
)

export const cancelOrder = createThunkFromApi(
  "trade/cancelOrder",
  tradeApi.cancelOrder
);

export const checkOrder = createThunkFromApi(
  "trade/checkOrder",
  tradeApi.checkOrder
);

export const getHistoryOrderForm = createThunkFromApi(
  "trade/getHistoryOrderForm",
  tradeApi.getHistoryOrderForm
);

export const getHistoryOrderList = createThunkFromApi(
  "trade/getHistoryOrderList",
  tradeApi.getHistoryOrderList
);

export const getOpenOrderList = createThunkFromApi(
  "trade/getOpenOrderList",
  tradeApi.getOpenOrderList
);

export const getOpenOrderForm = createThunkFromApi(
  "trade/getOpenOrderForm",
  tradeApi.getOpenOrderForm
);


const initialState = {
  // BACK OFFICE //

  tradeInsertForm: null,

  // BACK OFFICE //

  loading: false,
  tradeHistory: null,
  tradeAmountMax: null,
  tradeForm: null,
};

export const convertSlice = createSlice({
  name: "trade",
  initialState,

  extraReducers: {
    // BACK OFFICE //

    [getTradeInsertForm.pending]: (state) => {
      state.loading = true;
    },

    [getTradeInsertForm.rejected]: (state) => {
      state.loading = true;
    },

    [getTradeInsertForm.fulfilled]: (state, { payload }) => {
      state.tradeInsertForm = payload.data;
      state.loading = false;
    },

    [getTradeAmountMax.fulfilled]: (state, { payload }) => {
      state.tradeAmountMax = payload.data;
    },

    [getTradeList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },

    [getTradeForm.fulfilled]: (state, { payload }) => {
      state.tradeForm = payload.data;
    },

    [getOpenOrderForm.fulfilled]: (state, { payload }) => {
      state.tradeForm = payload.data;
    },

    [getHistoryOrderForm.fulfilled]: (state, { payload }) => {
      state.tradeForm = payload.data;
    },

    [getTradeLast24HList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },

    [getOpenOrderList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },
    // BACK OFFICE //

    [getHistoryOrderList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },
  },
});

export default convertSlice.reducer;
